import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import DOMPurify from "dompurify";
import DateTime from '_class/DateTime';
import { getMeeting, getMeetingInstance, updateMeetingInstanceDate, createMeetingFormInstance, requestMeetingCalendarInvite } from 'actions/meetings';
import { getFormInstance, getFormTemplate, updateFormInstance } from 'actions/templates';
import { setPageTitle } from 'actions/header';
import Modal from 'containers/Modals/Modal';
import FormInstance from 'containers/FormTemplate/Display/FormInstance';
import Message from 'containers/SinglePages/Partials/Message';
import StudentProgress from 'containers/Progress/StudentProgress';
import PostContent from 'components/Presentation/PostContent';
import SectionTitle from 'components/Presentation/SectionTitle';
import MeetingUsers from 'components/List/MeetingUsers';
import BookMeeting from '../Form/BookMeeting';
import { Spinner } from 'UI';
import Block, { BlockContent, BlockWrapper } from 'UI/Elements/Block';
import { Block as ContentBlock, Flex, Button, Checkbox, Tabs, Tab, translate } from '@haldor/ui';
import './Meeting.scss';
import { addError } from 'actions';
var MeetingInstance = /*#__PURE__*/function (_Component) {
  /* Class setup */
  function MeetingInstance(props) {
    var _this;
    _classCallCheck(this, MeetingInstance);
    _this = _callSuper(this, MeetingInstance, [props]);
    _defineProperty(_this, "componentDidMount", function () {
      _this.loadData();
    });
    _defineProperty(_this, "loadData", function () {
      var promise1 = _this.props.getMeeting(_this.props.match.params.id);
      var promise2 = _this.props.getMeetingInstance(_this.props.match.params.instanceId);
      var promises = [promise1, promise2];
      Promise.all(promises).then(function () {
        _this.props.setPageTitle(_this.props.meeting.title);
        _this.setState({
          loading: false
        });
      });
    });
    _defineProperty(_this, "toggleForm", function (reload) {
      _this.setState({
        formOpen: !_this.state.formOpen
      }, function () {
        if (reload) {
          _this.loadData();
        }
      });
    });
    _defineProperty(_this, "sendICS", function () {
      var _this$props = _this.props,
        meetingInstance = _this$props.meetingInstance,
        translate = _this$props.translate;
      _this.props.requestMeetingCalendarInvite(meetingInstance.id).then(function () {
        _this.props.addError(translate('Meeting invite sent to your email'), 'info');
      })["catch"](function () {
        _this.props.addError(translate('Could not send meeting invite'), 'error');
      });
    });
    _defineProperty(_this, "renderNote", function (reference) {
      var date = new DateTime(reference.created);
      var translate = _this.props.translate;
      return /*#__PURE__*/React.createElement("div", {
        className: "note",
        key: reference.id
      }, reference.title != null ? /*#__PURE__*/React.createElement("h3", null, reference.title) : null, /*#__PURE__*/React.createElement("p", {
        dangerouslySetInnerHTML: {
          __html: reference.text
        }
      }), /*#__PURE__*/React.createElement("p", {
        className: "creator"
      }, reference.author != null ? reference.author.firstName + " " + reference.author.lastName : null, /*#__PURE__*/React.createElement("span", {
        style: {
          fontWeight: 400
        }
      }, " ", date.getFromNow()), /*#__PURE__*/React.createElement("span", {
        style: {
          fontWeight: 400
        }
      }, ' • ', " ", reference["public"] != null && !reference["public"] ? translate('Private note') : translate('Shared note'))));
    });
    _defineProperty(_this, "toggleBooking", function () {
      _this.setState({
        bookingModal: !_this.state.bookingModal
      });
    });
    _defineProperty(_this, "unbookMeeting", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var obj;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            obj = {
              id: _this.props.meetingInstance.id,
              meetingId: _this.props.meeting.id,
              timeBlockSlotId: null,
              date: null,
              endDate: null
            };
            _this.setState({
              loading: true
            });
            _this.props.updateMeetingInstanceDate(obj, _this.props.meetingInstance.id).then(function () {
              _this.setState({
                loading: false
              });
            });
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_this, "onConversation", function (participant) {
      _this.setState({
        conversationMember: participant
      });
    });
    _defineProperty(_this, "onConversationClose", function () {
      _this.setState({
        conversationMember: null
      });
    });
    _defineProperty(_this, "submitFormInstance", function (values) {
      return new Promise( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resolve) {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                if (!(values.id == null)) {
                  _context2.next = 7;
                  break;
                }
                values.formID = _this.state.form.id;
                _context2.next = 4;
                return _this.props.createMeetingFormInstance(_this.props.meeting.id, _this.props.meetingInstance.id, values);
              case 4:
                _context2.next = 6;
                return _this.props.getMeetingInstance(_this.props.match.params.instanceId);
              case 6:
                resolve(1);
              case 7:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    });
    _defineProperty(_this, "onFormInstanceClick", function (form) {
      var formTemplate = JSON.parse(JSON.stringify(form.form.reference.formTemplate));
      var formTemplateFields = JSON.parse(JSON.stringify(form.form.reference.formTemplate.fields));
      _this.setState({
        formTemplate: formTemplate,
        formTemplateFields: formTemplateFields,
        form: form.form.reference,
        formInstance: form.formInstance
      });
      _this.toggleForm();
    });
    _defineProperty(_this, "renderForm", function (form, index) {
      var _form$formInstance;
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        onClick: function onClick() {
          return _this.onFormInstanceClick(form);
        },
        className: "form-item"
      }, /*#__PURE__*/React.createElement("div", {
        className: "cell title"
      }, form.form.reference.title), /*#__PURE__*/React.createElement("div", {
        className: "cell"
      }, form.participant.user.firstName, " ", form.participant.user.lastName), /*#__PURE__*/React.createElement("div", {
        className: "cell"
      }, form.formInstance != null ? new DateTime(form.formInstance.reference.edited).getLongDateWithTime() : ''), /*#__PURE__*/React.createElement("div", {
        className: "cell"
      }, ((_form$formInstance = form.formInstance) === null || _form$formInstance === void 0 ? void 0 : _form$formInstance.reference.status) == 'SUBMITTED' ? _this.props.translate('Turned in') : _this.props.translate('Not turned in')));
    });
    _this.state = {
      loading: true,
      formOpen: false,
      bookingModal: false,
      dateNow: new Date()
    };
    return _this;
  }
  _inherits(MeetingInstance, _Component);
  return _createClass(MeetingInstance, [{
    key: "getMeetingForms",
    value: function getMeetingForms() {
      var _this2 = this;
      var forms = this.props.meeting.relationships.filter(function (t) {
        if (t.referenceType == "FORM" && t.targetedAudience != "FOLLOWUP") {
          return true;
        }
        return false;
      }).map(function (t) {
        return t;
      });
      var returnForms = [];
      forms.forEach(function (form) {
        _this2.props.meetingInstance.participants.forEach(function (participant) {
          if (participant.userType == form.targetedAudience && participant.userID == _this2.props.user.id) {
            var formInstance = null;
            _this2.props.meetingInstance.relationships.forEach(function (relationship) {
              if (relationship.referenceType == "FORMINSTANCE") {
                if (relationship.reference.formID == form.referenceID && relationship.reference.assignedTo == participant.userID) {
                  formInstance = relationship;
                }
              }
            });
            returnForms.push({
              form: form,
              participant: participant,
              formInstance: formInstance
            });
          }
        });
      });
      return returnForms;
    }
  }, {
    key: "getFollowUpForms",
    value: function getFollowUpForms() {
      var _this3 = this;
      var forms = this.props.meeting.relationships.filter(function (t) {
        if (t.referenceType == "FORM" && t.targetedAudience == "FOLLOWUP") {
          return true;
        }
        return false;
      }).map(function (t) {
        return t;
      });
      var returnForms = [];
      forms.forEach(function (form) {
        var formInstance = null;
        _this3.props.meetingInstance.relationships.forEach(function (relationship) {
          if (relationship.referenceType == "FORMINSTANCE") {
            if (relationship.reference.formID == form.referenceID) {
              formInstance = relationship;
            }
          }
        });
        returnForms.push({
          form: form,
          formInstance: formInstance
        });
      });
      return returnForms;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state$formInsta,
        _this4 = this;
      if (this.state.loading) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }
      var _this$props2 = this.props,
        meeting = _this$props2.meeting,
        meetingInstance = _this$props2.meetingInstance,
        translate = _this$props2.translate;
      var notes = [];
      meetingInstance.relationships.forEach(function (relationship) {
        if (relationship.referenceType == "NOTE" && relationship.reference != null) {
          return notes.push(relationship.reference);
        }
      });
      notes.sort(function (a, b) {
        return new Date(b.created) - new Date(a.created);
      });
      var forms = this.getMeetingForms();
      var followUpForms = this.getFollowUpForms();
      var hasBooked = meetingInstance.date != null;
      var hasFilledForms = false;
      if (forms != null) {
        var foundUnfilledForm = forms.find(function (form) {
          return form.formInstance == null;
        });
        hasFilledForms = foundUnfilledForm == null;
      }
      var dateNow = new Date(this.state.dateNow);
      var startDate = new Date(meetingInstance.date);
      return /*#__PURE__*/React.createElement("div", {
        className: "single-task meeting single-instance"
      }, /*#__PURE__*/React.createElement(Modal, {
        title: translate('Forms'),
        isOpen: this.state.formOpen,
        onClose: this.toggleForm
      }, this.state.formTemplate != null ? /*#__PURE__*/React.createElement(FormInstance, {
        form: this.state.formTemplate.id.toString(),
        fields: this.state.formTemplateFields,
        instance: (_this$state$formInsta = this.state.formInstance) === null || _this$state$formInsta === void 0 ? void 0 : _this$state$formInsta.reference,
        onAbort: this.toggleForm,
        onSubmit: this.submitFormInstance,
        disabled: meeting.status == 'COMPLETED'
      }) : /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })), /*#__PURE__*/React.createElement(Message, {
        activeUser: this.state.conversationMember,
        meetingInstance: meetingInstance,
        onClose: this.onConversationClose
      }), /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.bookingModal,
        onClose: function onClose() {
          return _this4.toggleBooking();
        },
        type: "small",
        title: translate('Book a meeting')
      }, /*#__PURE__*/React.createElement(BookMeeting, {
        onClose: function onClose() {
          _this4.toggleBooking();
        },
        meeting: meeting,
        instance: meetingInstance
      })), /*#__PURE__*/React.createElement("div", {
        className: "single-section form left-side",
        style: {
          paddingTop: 0
        }
      }, /*#__PURE__*/React.createElement(Tabs, null, /*#__PURE__*/React.createElement(Tab, {
        title: translate('Meeting information'),
        route: "info"
      }, (!hasBooked || !hasFilledForms) && meeting.status !== 'COMPLETED' || meeting.status === 'ACTIVE' && (meetingInstance.status === 'DRAFT' || meetingInstance.status === 'ACTIVE') ? /*#__PURE__*/React.createElement(ContentBlock, null, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, translate('To do')), /*#__PURE__*/React.createElement("div", null, !hasBooked ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        onClick: this.toggleBooking,
        style: {
          display: 'inline-block',
          marginBottom: '.35rem',
          cursor: 'pointer'
        }
      }, /*#__PURE__*/React.createElement(Checkbox, {
        value: false,
        label: translate('Book a meeting'),
        disabled: true
      }))) : null, !hasFilledForms ? /*#__PURE__*/React.createElement("a", {
        href: "#forms",
        style: {
          marginBottom: '.35rem',
          cursor: 'pointer',
          color: '#3a3a3a',
          textDecoration: 'none'
        }
      }, /*#__PURE__*/React.createElement(Checkbox, {
        value: false,
        label: translate('Fill form'),
        disabled: true
      })) : null)) : null, /*#__PURE__*/React.createElement(ContentBlock, null, meetingInstance.date != null ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '1rem'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, translate('Time')), new DateTime(meetingInstance.date).getLongDate(), ' • ', new DateTime(meetingInstance.date).getTime(), meetingInstance.endDate != null ? ' - ' + new DateTime(meetingInstance.endDate).getTime() : null) : null, meetingInstance.studentLed ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '.55rem'
        },
        className: "color--meta size-14"
      }, translate('Student will lead the meeting')) : null, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, translate('Meeting information')), meeting.status === 'COMPLETED' ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '.55rem'
        },
        className: "color--meta size-14"
      }, translate('Meeting completed')) : null, /*#__PURE__*/React.createElement(PostContent, null, meeting.description), /*#__PURE__*/React.createElement(PostContent, null, meetingInstance.description), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, translate('Participants')), /*#__PURE__*/React.createElement(MeetingUsers, {
        users: meetingInstance.participants,
        schoolId: meeting.schoolID,
        onConversation: this.onConversation
      })))), this.props.student.services.notes ? /*#__PURE__*/React.createElement(Tab, {
        title: translate('Meeting notes'),
        route: "notes"
      }, /*#__PURE__*/React.createElement(ContentBlock, null, /*#__PURE__*/React.createElement("div", {
        className: "notes"
      }, /*#__PURE__*/React.createElement(Flex, {
        center: true
      }, /*#__PURE__*/React.createElement("span", {
        className: "title",
        style: {
          flex: 1
        }
      }, translate('Meeting notes'))), notes.map(function (note) {
        return _this4.renderNote(note);
      }), notes.length == 0 ? /*#__PURE__*/React.createElement("div", null, translate('No notes')) : null))) : null, /*#__PURE__*/React.createElement(Tab, {
        title: translate('Forms'),
        route: "forms"
      }, /*#__PURE__*/React.createElement(ContentBlock, null, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, translate('Forms')), /*#__PURE__*/React.createElement("div", {
        className: "meeting-forms"
      }, forms.map(this.renderForm)))))), /*#__PURE__*/React.createElement("div", {
        className: "single-actions right-side",
        style: {
          paddingTop: 0
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "action-section"
      }, /*#__PURE__*/React.createElement("h3", null, translate('Student')), meetingInstance.student != null ? /*#__PURE__*/React.createElement("div", null, meetingInstance.student.firstName + " " + meetingInstance.student.lastName) : null), meetingInstance.date != null && meetingInstance.endDate != null && meeting.status !== 'COMPLETED' && startDate > dateNow ? /*#__PURE__*/React.createElement("div", null, this.props.profile.mail != null ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
        onClick: this.sendICS,
        type: "secondary"
      }, translate('Download calendar file'))) : null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
        style: {
          marginTop: 5
        },
        onClick: function onClick() {
          _this4.toggleBooking();
        },
        type: "secondary"
      }, translate('Book a meeting'))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
        style: {
          marginTop: 5
        },
        onClick: function onClick() {
          _this4.unbookMeeting();
        },
        type: "secondary"
      }, translate('Cancel meeting')))) : null, meetingInstance.teamsMeetingData != null ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '.5rem'
        }
      }, /*#__PURE__*/React.createElement("a", {
        href: meetingInstance.teamsMeetingData.joinWebUrl,
        target: "_blank"
      }, translate('Join Teams meeting'))) : null), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }), /*#__PURE__*/React.createElement("div", {
        className: "section single-section form"
      }, /*#__PURE__*/React.createElement(SectionTitle, null, /*#__PURE__*/React.createElement("span", null, translate('Follow up'))), /*#__PURE__*/React.createElement(BlockWrapper, {
        cols: "1"
      }, /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement(BlockContent, null, followUpForms != null && followUpForms.length > 0 ? followUpForms.map(function (form, i) {
        var _form$formInstance2;
        return /*#__PURE__*/React.createElement("div", {
          key: i
        }, /*#__PURE__*/React.createElement(SectionTitle, null, translate('Forms'), " ", i + 1), /*#__PURE__*/React.createElement(FormInstance, {
          form: form.form.referenceID.toString(),
          fields: form.form.reference.formTemplate.fields,
          formTemplate: form.form.reference.formTemplate,
          instance: (_form$formInstance2 = form.formInstance) === null || _form$formInstance2 === void 0 ? void 0 : _form$formInstance2.reference,
          followUp: true
        }));
      }) : /*#__PURE__*/React.createElement("div", {
        style: {
          textAlign: "center"
        }
      }, translate('Follow up is not available yet')))))), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }), /*#__PURE__*/React.createElement("div", {
        className: "section single-section form",
        style: {
          marginTop: 0,
          paddingTop: '1.9em'
        }
      }, /*#__PURE__*/React.createElement(SectionTitle, null, /*#__PURE__*/React.createElement("span", null, translate('Student card'))), /*#__PURE__*/React.createElement(BlockWrapper, {
        cols: "1"
      }, /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement(BlockContent, null, /*#__PURE__*/React.createElement(StudentProgress, {
        noTitle: true
      }))))));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    profile: state.profile.profile,
    meeting: state.Meetings.meeting,
    meetingInstance: state.Meetings.meetingInstance,
    meetingTimeBlockSlots: state.TimeBlocks.meetingTimeBlockSlots,
    formTemplate: state.Templates.formTemplate,
    formInstance: state.Templates.instance,
    user: state.User.user,
    translate: translate(state.Languages.translations),
    student: state.User.activeStudent
  };
}
export default connect(mapStateToProps, {
  getMeetingInstance: getMeetingInstance,
  getMeeting: getMeeting,
  getFormTemplate: getFormTemplate,
  getFormInstance: getFormInstance,
  createMeetingFormInstance: createMeetingFormInstance,
  updateFormInstance: updateFormInstance,
  setPageTitle: setPageTitle,
  updateMeetingInstanceDate: updateMeetingInstanceDate,
  requestMeetingCalendarInvite: requestMeetingCalendarInvite,
  addError: addError
})(MeetingInstance);